import { schedularAnnouncementActions } from './../../actions/constant';

const {
  UPDATE_ANNOUNCEMENT_REQUEST,
  UPDATE_ANNOUNCEMENT_SUCCESS,
  UPDATE_ANNOUNCEMENT_FAILURE,
  UPDATE_ANNOUNCEMENT_RESET,
} = schedularAnnouncementActions;

const initialState: object = {
  response: null,
  loading: false,
};
export const updateAnnouncementReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case UPDATE_ANNOUNCEMENT_REQUEST: {
      return { ...state, loading: true };
    }

    case UPDATE_ANNOUNCEMENT_SUCCESS: {
      return { ...state, response: action.payload, loading: false };
    }

    case UPDATE_ANNOUNCEMENT_FAILURE: {
      return { ...state, response: action.payload, loading: false };
    }

    case UPDATE_ANNOUNCEMENT_RESET:
      return initialState;

    default:
      return state;
  }
};
